import axiosInstance from "../../apiAxios/axiosInstance";


export const loginAdmin = async (loginData) => {
  const response = await axiosInstance.post("/admin-login", loginData);
  return response.data;
};

export const sendOtp = async (mobile) => {
  const response = await axiosInstance.post('/vendor/vendor-send-otp', { mobile });
  return response.data;
}
export const getAdminProfile = async () => {
  const response = await axiosInstance.get("/admin/admin-profile");
  return response;
};
export const getVendorProfile = async () => {
  const response = await axiosInstance.get("/vendor/profile");
  return response;
};
export const verifyOtp = async (mobile, otp) => {
  const response = await axiosInstance.post('/vendor/vendor-verify-otp', { mobile, otp });

  if (response.data.status === false) {
    throw new Error(response.data.message || 'Invalid OTP');
  }

  const { token, token_type, vendor } = response.data.data;
  localStorage.setItem('token', token);
  localStorage.setItem('token_type', token_type || 'Bearer');
  localStorage.setItem('vendor', JSON.stringify(vendor));
  localStorage.setItem('isLoggedIn', 'true');
  localStorage.setItem('kyc_status', vendor?.kyc_status || 'pending');

  return response.data;
};

/* =========================================================
   🔁 RESEND OTP
========================================================= */
export const resendOtp = async (mobile) => {
  const response = await axiosInstance.post('/vendor/vendor-resend-otp', { mobile });
  return response.data;
};
export const profileUpdateOtp = async (payload) => {
  const response = await axiosInstance.post('/vendor/profile-update', payload);
  return response.data;
};

export const getDashboardCounts = async () => {
  const response = await axiosInstance.get("/vendor/vendor-dashboard-count-list");
  return response.data;
};


export const changeAdminPassword = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/vendor-change-password",
    payload
  );
  return response.data;
};
export const logoutAdmin = async () => {
  const response = await axiosInstance.post("/vendor/logout");
  return response.data;
};

// export const getStaffPermissions = async (staffId) => {
//   const response = await axiosInstance.post(
//     "/admin/staff-permissions",
//     {
//       id: staffId,
//     }
//   );
//   return response.data;
// };

export const getStaffPermissions = async (id) => {
  const response = await axiosInstance.post("/admin/staff-permissions", {
    id,
  });

  return response.data;
};